<template>
    <div ref="overviewWrapper"
         class="resource-overview">
        <div class="overview-content">
            <div style="height: 350px;line-height: 350px;position: relative;top:120px">
                <div  class="search-content">
                    <div class="search-input-mask">
                        <input type="input" placeholder="请输入文章关键字" v-model="searchWord" @keyup.enter="goSearchResult">
                    </div>
                    <div :style="{backgroundColor: themeColor}" class="search-icon"  @click="goSearchResult" >
                        <img src="@/assets/search.png">
                    </div>
                </div>
            </div>
            <div class="site-footer">
                    <Footer/>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Footer from '@/components/footer'
    export default {
        components: {
            Footer
        },
        data () {
            return {
                searchWord: ''
            }
        },
        computed: {
                themeColor () {
                return this.$store.state.themeColor
            }
        },
        methods:
        {
            goSearchResult () {
                const {searchWord} = this;
                if (searchWord) {
                    this.searchWord = ''
                    this.$router.push({
                        name: 'searchResults',
                        params: {
                            resourceType:'articleLibrary',
                            searchWord
                        }
                    })
                }
            }
        }
    }
</script>

<style type="text/css">
         
</style>
<style lang="scss" scoped>
    
     .resource-overview {
        width: 100%;
        height: 100%;
        overflow: hidden; 
     }   
     .overview-content {
            width: 1140px;
            margin: 0 auto;
     }
    .search-content {
            width: 540px;
            height: 40px;
            overflow: hidden;
            background: #F6F6F6;
            border: 1px solid #EBEBEB;
            border-radius: 4px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            margin: 0 auto;
            .search-input-mask {
                width: 500px;
                height: 40px;
                box-sizing: border-box;
                margin: 0;
                padding: 0 12px;
                
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                background: white;
            }
            input {
                width: 450px;
                height: 30px;
                font-size: 14px;
                line-height: 1em;
                color: #8590A6;
            }
            .search-icon {
                width: 40px;
                height: 40px;
                background: #0084FF;
                cursor: pointer;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                border: 1px solid #EBEBEB;
                border-radius:0px 4px 4px 0px;
             }
    }
</style>